// Linkable routes
export type RegionsRouteType = 'regions'
export const REGIONS_ROUTE: RegionsRouteType = 'regions'

export type SuggestToRegionRouteType = 'recommend'
export const SUGGEST_TO_REGION_ROUTE: SuggestToRegionRouteType = 'recommend'

export type CategoriesRouteType = 'categories'
export const CATEGORIES_ROUTE: CategoriesRouteType = 'categories'

export type PlacesRouteType = 'places'
export const PLACES_ROUTE: PlacesRouteType = 'places'

export type EventsRouteType = 'events'
export const EVENTS_ROUTE: EventsRouteType = 'events'

export type NewsRouteType = 'news'
export const NEWS_ROUTE: NewsRouteType = 'news'

export type ImprintRouteType = 'imprint'
export const IMPRINT_ROUTE: ImprintRouteType = 'imprint'

export type SearchRouteType = 'search'
export const SEARCH_ROUTE: SearchRouteType = 'search'

export type OpenSourceRouteType = 'open-source'
export const OPEN_SOURCE_ROUTE: OpenSourceRouteType = 'open-source'

// Legacy routes
export const LEGACY_REGIONS_ROUTE = 'landing'
export const LEGACY_PLACES_ROUTE = 'locations'

// Internal native routes
export type CategoriesTabRouteType = 'categoriesTab'
export const CATEGORIES_TAB_ROUTE: CategoriesTabRouteType = 'categoriesTab'
export type EventsTabRouteType = 'eventsTab'
export const EVENTS_TAB_ROUTE: EventsTabRouteType = 'eventsTab'
export type PlacesTabRouteType = 'placesTab'
export const PLACES_TAB_ROUTE: PlacesTabRouteType = 'placesTab'
export type NewsTabRouteType = 'newsTab'
export const NEWS_TAB_ROUTE: NewsTabRouteType = 'newsTab'

export type RedirectRouteType = 'redirect'
export const REDIRECT_ROUTE: RedirectRouteType = 'redirect'

export type IntroRouteType = 'intro'
export const INTRO_ROUTE: IntroRouteType = 'intro'

export type SettingsRouteType = 'settings'
export const SETTINGS_ROUTE: SettingsRouteType = 'settings'

export type BottomTabRouteType = 'bottomTab'
export const BOTTOM_TAB_ROUTE: BottomTabRouteType = 'bottomTab'

export type LanguagesRouteType = 'languages'
export const LANGUAGES_ROUTE: LanguagesRouteType = 'languages'

export type PdfViewRouteType = 'pdf'
export const PDF_VIEW_ROUTE: PdfViewRouteType = 'pdf'

export type ImageViewRouteType = 'image'
export const IMAGE_VIEW_ROUTE: ImageViewRouteType = 'image'

export type FeedbackRouteType = 'feedback'
export const FEEDBACK_ROUTE: FeedbackRouteType = 'feedback'

export type ExternalSourcesRouteType = 'consent'
export const EXTERNAL_SOURCES_ROUTE: ExternalSourcesRouteType = 'consent'

export type ChatRouteType = 'chat'
export const CHAT_ROUTE: ChatRouteType = 'chat'

// Web routes
export type MainImprintRouteType = 'main-imprint'
export const MAIN_IMPRINT_ROUTE: MainImprintRouteType = 'main-imprint'

export type NotFoundRouteType = 'not-found'
export const NOT_FOUND_ROUTE: NotFoundRouteType = 'not-found'

// Changes done to the reserved routes have to be done in the CMS as well:
// https://github.com/digitalfabrik/integreat-cms/blob/main/integreat_cms/core/settings.py#L69-78
export const RESERVED_TOP_LEVEL_SLUGS: string[] = [
  REGIONS_ROUTE,
  MAIN_IMPRINT_ROUTE,
  NOT_FOUND_ROUTE,
  EXTERNAL_SOURCES_ROUTE,
  OPEN_SOURCE_ROUTE,
  SUGGEST_TO_REGION_ROUTE,
  LEGACY_REGIONS_ROUTE,
]

// Changes done to the reserved routes have to be done in the CMS as well:
// https://github.com/digitalfabrik/integreat-cms/blob/main/integreat_cms/core/settings.py#L80-L88
export const RESERVED_REGION_CONTENT_SLUGS: string[] = [
  SEARCH_ROUTE,
  IMPRINT_ROUTE,
  EVENTS_ROUTE,
  NEWS_ROUTE,
  PLACES_ROUTE,
  LEGACY_PLACES_ROUTE,
]
